module.exports = __webpack_public_path__ + "assets/img/img-talk-02.90ad1589.jpg";